const ITEMS = [
  "Corporate Advisory",
  "Intellectual Property",
  "Commercial Contracts",
  "Regulatory Governance",
  "Property Due Diligence",
  "Dispute Resolution",
  "Brand Protection",
  "Legal Documentation",
];

const Row = ({ ariaHidden = false }) => (
  <div
    aria-hidden={ariaHidden}
    className="flex shrink-0 items-center"
  >
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-mono text-xs uppercase tracking-widest2 text-white/55 sm:px-12">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/80" aria-hidden="true" />
      </span>
    ))}
  </div>
);

// One slow editorial marquee — each tenet appears once per loop.
export const Marquee = () => (
  <div
    className="relative overflow-hidden border-y border-white/10 bg-navy-dark py-6"
    data-testid="editorial-marquee"
  >
    <div className="flex w-max animate-marquee will-change-transform">
      <Row />
      <Row ariaHidden />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-dark to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-dark to-transparent" />
  </div>
);
